/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
<template>
  <div>
    <navebar />
  </div>
</template>

<script>
/* eslint-disable */
import navebar from "./commom/navebar/navbar.vue";

export default {
  name: "App",
  components: { navebar },

beforeMount() {
  // Try same-origin direct call first
  let called = false;
  try {
    if (window.parent && typeof window.parent.showAlert === 'function') {
      window.parent.showAlert('Hello from iframe!');
      called = true;
    }
  } catch (e) {
    // Cross-origin access throws—ignore and use postMessage
  }

  if (!called) {
    // Use the parent’s exact origin if it’s different. If same-origin, window.location.origin is fine.
    const parentOrigin = window.location.origin; // <-- change to your parent origin if different
    window.parent.postMessage({ type: 'SHOW_ALERT', payload: 'Hello from iframe!' }, parentOrigin);
  }
  },

  methods: {
    alertIfInIframe() {
      let inIframe = false;
      try {
        // If framed by another origin, this comparison is still safe.
        inIframe = window.self !== window.top;
      } catch (e) {
        // If accessing window.top throws (sandbox/cross-origin), we are in an iframe.
        inIframe = true;
      }
      if (inIframe) {
        alert("on iframe");
      }
    }
  }
};
</script>
